import {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {getRichResidentObject} from '../../Utils/residentUtils'
import {selectCombinedResidentsLookup, selectCombinedOccupanciesLookup, selectCombinedUnitsLookup} from '../../reducers/selectors'

/**
 * Similar to useResidentLookup but uses combined data from both the active building
 * and sister buildings. Use this hook in amenities and events features where
 * residents from sister buildings may book shared amenities.
 *
 * @return {{getResident: (function(string): RichResidentObject)}}
 */
function useCombinedResidentLookup() {
  const residentsLookup = useSelector(selectCombinedResidentsLookup)
  const occupanciesLookup = useSelector(selectCombinedOccupanciesLookup)
  const unitsLookup = useSelector(selectCombinedUnitsLookup)

  /**
   * @param {string} residentId
   * @return {RichResidentObject}
   */
  const getResident = useCallback(residentId => {
    return getRichResidentObject(residentsLookup, occupanciesLookup, unitsLookup, residentId)
  }, [residentsLookup, occupanciesLookup, unitsLookup])

  return {
    getResident,
  }
}

export default useCombinedResidentLookup
